import GlobalSettings from './slices/globalSettings.slice';

export const SharedReducers = {
  globalSettings: GlobalSettings,
};
